class Constants {
  static FETCH_USER_REQUEST = "FETCH_USER_REQUEST";
  static FETCH_USER_SUCCESS = "FETCH_USER_SUCCESS";
  static FETCH_USER_FAILURE = "FETCH_USER_FAILURE";

  static MAINTENANCE_REQUEST =  "MAINTENANCE_REQUEST";
  static MAINTENANCE_SUCCESS =  "MAINTENANCE_SUCCESS";
  static MAINTENANCE_FAILURE =  "MAINTENANCE_FAILURE";

  static CREATE_MAINTENANCE_REQUEST =  "CREATE_MAINTENANCE_REQUEST";
  static CREATE_MAINTENANCE_SUCCESS =  "CREATE_MAINTENANCE_SUCCESS";
  static CREATE_MAINTENANCE_FAILURE =  "CREATE_MAINTENANCE_FAILURE";

  static TENANT_REQUEST =  "TENANT_REQUEST";
  static TENANT_SUCCESS =  "TENANT_SUCCESS";
  static TENANT_FAILURE =  "TENANT_FAILURE";

  static CREATE_TENANT_REQUEST =  "CREATE_TENANT_REQUEST";
  static CREATE_TENANT_SUCCESS =  "CREATE_TENANT_SUCCESS";
  static CREATE_TENANT_FAILURE =  "CREATE_TENANT_FAILURE";

  static DISCLAIMER_REQUEST =  "DISCLAIMER_REQUEST";
  static DISCLAIMER_SUCCESS =  "DISCLAIMER_SUCCESS";
  static DISCLAIMER_FAILURE =  "DISCLAIMER_FAILURE";

  static CREATE_DISCLAIMER_REQUEST =  "CREATE_DISCLAIMER_REQUEST";
  static CREATE_DISCLAIMER_SUCCESS =  "CREATE_DISCLAIMER_SUCCESS";
  static CREATE_DISCLAIMER_FAILURE =  "CREATE_DISCLAIMER_FAILURE";

  static GET_ALLDISCLAIMER_REQUEST =  "GET_ALLDISCLAIMER_REQUEST";
  static GET_ALLDISCLAIMER_SUCCESS =  "GET_ALLDISCLAIMER_SUCCESS";
  static GET_ALLDISCLAIMER_FAILURE =  "GET_ALLDISCLAIMER_FAILURE";

  static ADDITIONALFEE_REQUEST =  "ADDITIONALFEE_REQUEST";
  static ADDITIONALFEE_SUCCESS =  "ADDITIONALFEE_SUCCESS";
  static ADDITIONALFEE_FAILURE =  "ADDITIONALFEE_FAILURE";

  static CREATE_ADDITIONALFEE_REQUEST =  "CREATE_ADDITIONALFEE_REQUEST";
  static CREATE_ADDITIONALFEE_SUCCESS =  "CREATE_ADDITIONALFEE_SUCCESS";
  static CREATE_ADDITIONALFEE_FAILURE =  "CREATE_ADDITIONALFEE_FAILURE";

  static GET_ADDITIONALFEE_REQUEST =  "GET_ADDITIONALFEE_REQUEST";
  static GET_ADDITIONALFEE_SUCCESS =  "GET_ADDITIONALFEE_SUCCESS";
  static GET_ADDITIONALFEE_FAILURE =  "GET_ADDITIONALFEE_FAILURE";

  static GET_ALLADDITIONALFEE_REQUEST =  "GET_ALLADDITIONALFEE_REQUEST";
  static GET_ALLADDITIONALFEE_SUCCESS =  "GET_ALLADDITIONALFEE_SUCCESS";
  static GET_ALLADDITIONALFEE_FAILURE =  "GET_ALLADDITIONALFEE_FAILURE";

  static UPDATE_TENANT_PAYEMENT_REQUEST =   "UPDATE_TENANT_PAYEMENT_REQUEST";
  static UPDATE_TENANT_PAYEMENT_SUCCESS =   "UPDATE_TENANT_PAYEMENT_SUCCESS";
  static UPDATE_TENANT_PAYEMENT_FAILURE =   "UPDATE_TENANT_PAYEMENT_FAILURE";

  static GET_ALLCITIESFROMSTATE_REQUEST =  "GET_ALLCITIESFROMSTATE_REQUEST";
  static GET_ALLCITIESFROMSTATE_SUCCESS =  "GET_ALLCITIESFROMSTATE_SUCCESS";
  static GET_ALLCITIESFROMSTATE_FAILURE =  "GET_ALLCITIESFROMSTATE_FAILURE";

  static SET_SKIPPED_PAYMENT_REQUEST =  "SET_SKIPPED_PAYMENT_REQUEST";
  static SET_SKIPPED_PAYMENT_SUCCESS =  "SET_SKIPPED_PAYMENT_SUCCESS";
  static SET_SKIPPED_PAYMENT_FAILURE =  "SET_SKIPPED_PAYMENT_FAILURE";

  static AUTH_TOKEN = 'auth_token'
}

export default Constants;
